import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loginData: null,
    qrCode: null
  },
  mutations: {
    SET_LOGIN_DATA: (state, data) => {
      state.loginData = data
    },
    SET_QR_CODE: (state, data) => {
      state.qrCode = data
    },
  },
  actions: {}
})
